import { useTranslation } from "react-i18next";
import ListGroup from "./controls/ListGroup";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import ObjectValue from "./controls/ObjectValue";
import Col from "./layout/Col";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import TextValue from "./controls/TextValue";
import LabeledValue from "./controls/LabeledValue";
import MeasureValue from "./controls/MeasureValue";
import { TanqueAcopioLiquidoSchema } from "../data/TanqueAcopioLiquidoSchema";

export function TanqueAcopioLiquidoList({ value, select, remove, disabled }) {
  const { t } = useTranslation();
  return (
    <ListGroup>
      {value.map((item, index) => {
        const isInvalid = !TanqueAcopioLiquidoSchema.isValidSync(item, {
          abortEarly: false,
        });
        return (
          <ListGroupObjectItem
            key={item.orden ?? index}
            index={index}
            indexLabel={t("tanqueAcopioLiquido.orden")}
            value={item}
            className={isInvalid ? "has-error" : ""}
            editable
            onEdit={(event) => {
              event.preventDefault();
              select(index);
              document.getElementById("tanquesAcopioLiquidos").scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
            deletable
            onDelete={(event) => {
              event.preventDefault();
              remove(index);
            }}
            disabled={disabled}
          >
            {({ value }) => (
              <Grid>
              <Row>
                <Col>
                  <ObjectValue
                    label={t("tanqueAcopioLiquido.sustanciaQuimica")}
                    value={value?.sustanciaQuimica}
                  >
                    {({ value: sustanciaQuimica }) => (
                      <Grid>
                        <Row>
                          <Col>
                            <TextValue
                              label={t("liquidoAcopiado.nombreComercial")}
                              value={sustanciaQuimica?.nombreComercial}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <TextValue
                              label={t("liquidoAcopiado.CAS")}
                              value={sustanciaQuimica?.CAS}
                            />
                          </Col>
                        </Row>
                      </Grid>
                    )}
                  </ObjectValue>
                </Col>
              </Row>
              <Row>
                <Col>
                  <LabeledValue
                    label={t("tanqueAcopioLiquido.clasificacion")}
                    value={value?.clasificacion}
                    labelAttr="nombre"
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <MeasureValue
                    label={t("tanqueAcopioLiquido.altura")}
                    value={value?.altura}
                  />
                </Col>
                <Col lg={4}>
                  <MeasureValue
                    label={t("tanqueAcopioLiquido.alturaLiquido")}
                    value={value?.alturaLiquido}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <MeasureValue
                    label={t("tanqueAcopioLiquido.diametro")}
                    value={value?.diametro}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <MeasureValue
                    label={t("tanqueAcopioLiquido.volumenOperacional")}
                    value={value?.volumenOperacional}
                  />
                </Col>
                <Col lg={4}>
                  <MeasureValue
                    label={t("tanqueAcopioLiquido.volumenTotal")}
                    value={value?.volumenTotal}
                  />
                </Col>
              </Row>
              </Grid>
            )}
          </ListGroupObjectItem>
        );
      })}
    </ListGroup>
  );
}
